// src/App.js
import React from 'react';
import Survey from './Survey';
import './styles.css';

function App() {
  return (
    <div className="App">
      <h1>Euro 2008'deki Türkiye performansına ne kadar hakimsin?</h1>
      <Survey />
      
    </div>
  );
}

export default App;
